import { Check, Circle } from 'lucide-react';
import { cn } from '../../lib/utils';
import type { InstructionStepDto } from './types';
import { InstructionStepKindKey } from './lessonStepState';

interface LessonStepProgressListProps {
    steps: InstructionStepDto[];
    className?: string;
}

function stepKindLabel(kind?: string): string | null {
    switch (kind) {
        case InstructionStepKindKey.WrapUp:
            return 'Wrap up';
        case InstructionStepKindKey.Review:
            return 'Review';
        default:
            return null;
    }
}

export function LessonStepProgressList({ steps, className }: LessonStepProgressListProps) {
    if (!steps.length) return null;

    return (
        <ul className={cn('space-y-1.5', className)}>
            {steps.map((step, index) => {
                const completed = step.e251_IsCompleted === true;
                const label =
                    step.e251_Summary?.trim() ||
                    `Step ${step.e251_StepNumber ?? index + 1}`;
                const kind = stepKindLabel(step.e251_StepKind);

                return (
                    <li
                        key={step.e251_StepId ?? `step-${index}`}
                        className={cn(
                            'flex items-start gap-2 text-sm',
                            completed ? 'text-gray-500' : 'text-gray-800'
                        )}
                    >
                        {completed ? (
                            <Check
                                size={16}
                                className="mt-0.5 shrink-0 text-vibrant-green"
                                aria-hidden
                            />
                        ) : (
                            <Circle
                                size={16}
                                className="mt-0.5 shrink-0 text-gray-400"
                                aria-hidden
                            />
                        )}
                        <span className={cn(completed && 'line-through')}>
                            {label}
                            {kind ? (
                                <span className="ml-1 text-xs text-gray-500">({kind})</span>
                            ) : null}
                        </span>
                    </li>
                );
            })}
        </ul>
    );
}
